var prefix = 'ak-editor-expand';
export var expandClassNames = {
    prefix: prefix,
    expanded: prefix + "__expanded",
    titleContainer: prefix + "__title-container",
    inputContainer: prefix + "__input-container",
    iconContainer: prefix + "__icon-container",
    icon: prefix + "__icon",
    titleInput: prefix + "__title-input",
    content: prefix + "__content",
    type: function (type) { return prefix + "__type-" + type; },
};
//# sourceMappingURL=class-names.js.map